import { EntityTypeCode, useFetchCallType, useViewerEntity } from '@rahtab/auth/lib/token-based-auth';
import { useAlert } from '@rahtab/ui';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { RootStackType } from '../../Router';

export const useAnounceDelivery = ({
  assignFinalCode,
  date,
  receiveAmount,
  receiveComment,
  merchandiseId,
  receiveMatch,
  receivePricePerUnit,
  receiveTotalPrice,
}: AnounceDeliveryArgs) => {
  const { viewerSelectedEntity } = useViewerEntity();
  const alert = useAlert();
  const { goBack, navigate } = useNavigation<NavigationProp<RootStackType>>();
  const anounceAssignFinalData: ServerRequestedData = {
    AssignFinallCode: assignFinalCode,
    ReceiveAmount: receiveAmount,
    ReceiveComment: receiveComment,
    ReceiveDate: date,
    ReceiveMatch: receiveMatch ? '1' : '0',
    ReceivePricePerUnit: receivePricePerUnit,
    ReceiveTotalPrice: receiveTotalPrice,
  };

  const anounceAssignFinalFormData = new FormData();
  anounceAssignFinalFormData.append('ReceiveInfo', JSON.stringify(anounceAssignFinalData));

  const [
    anounceAssignFinal,
    { loading: loadingAssignFinallReceipt, called: calledAssignFinallReceipt },
  ] = useFetchCallType<ServerResponse>('AssignFinallReceipt', {
    method: 'POST',
    data: anounceAssignFinalFormData,
    skip: true,
    onCompleted: (data) => {
      if (data?.result) {
        if (data.statusCode === '1') {
          alert({
            severity: 'success',
            message: data.message,
            hideBackButton: true,
            buttons: buttons,
          });
        } else {
          const btns = [
            ...buttons,
            {
              text: 'مشاهده بارهای موجود',
              color: 'primary' as 'primary',
              onPress: () => navigate('LoadsList', { merchandiseId }),
            },
          ];
          alert({
            severity: 'success',
            message: data.message,
            hideBackButton: true,
            buttons: btns,
          });
        }
      } else if (data?.result === false) {
        alert({
          message: data?.error,
        });
      }
    },
  });
  const anounceAssignPrimaryData: Omit<ServerRequestedData, 'AssignFinallCode'> & {
    AssignPrimaryCode: ServerRequestedData['AssignFinallCode'];
  } = {
    AssignPrimaryCode: assignFinalCode,
    ReceiveAmount: receiveAmount,
    ReceiveComment: receiveComment,
    ReceiveDate: date,
    ReceiveMatch: receiveMatch ? '1' : '0',
    ReceivePricePerUnit: receivePricePerUnit,
    ReceiveTotalPrice: receiveTotalPrice,
  };

  const anounceAssignPrimaryFormData = new FormData();
  anounceAssignPrimaryFormData.append('ReceiveInfo', JSON.stringify(anounceAssignPrimaryData));
  const [
    anounceAssignPrimary,
    { loading: loadingAssignPrimaryReceipt, called: calledAssignPrimaryReceipt, data: assignPrimaryReceipt },
  ] = useFetchCallType<ServerResponse>('AssignPrimaryReceipt', {
    method: 'POST',
    data: anounceAssignPrimaryFormData,
    skip: true,
    onCompleted: (data) => {
      if (data?.result) {
        if (data.statusCode === '1') {
          alert({
            severity: 'success',
            message: data.message,
            hideBackButton: true,
            buttons: buttons,
          });
        } else {
          const btns = [
            ...buttons,
            {
              text: 'مشاهده بارهای موجود',
              color: 'primary' as 'primary',
              onPress: () => navigate('LoadsList', { merchandiseId }),
            },
          ];
          alert({
            severity: 'success',
            message: data.message,
            hideBackButton: true,
            buttons: btns,
          });
        }
      } else if (data?.result === false) {
        alert({
          message: data?.error,
        });
      }
    },
  });

  const buttons = [
    {
      text: 'بازگشت',
      variant: 'outlined' as 'outlined',
      color: 'primary' as 'primary',
      onPress: () => goBack(),
    },
  ];
  // useEffect(() => {
  //   if (!loading) {
  //     if (data?.result) {
  //       if (data.statusCode === '1') {
  //         alert({
  //           severity: 'success',
  //           message: data.message,
  //           hideBackButton: true,
  //           buttons: buttons,
  //         });
  //       } else {
  //         const btns = [
  //           ...buttons,
  //           {
  //             text: 'مشاهده بارهای موجود',
  //             color: 'primary' as 'primary',
  //             onPress: () => navigate('LoadsList', { merchandiseId }),
  //           },
  //         ];
  //         alert({
  //           severity: 'success',
  //           message: data.message,
  //           hideBackButton: true,
  //           buttons: btns,
  //         });
  //       }
  //     } else if (data?.result === false) {
  //       alert({
  //         message: data?.error,
  //       });
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [loading, data]);
  return {
    anounce: viewerSelectedEntity?.typeCode === EntityTypeCode.Middleman ? anounceAssignPrimary : anounceAssignFinal,
    loading: loadingAssignFinallReceipt || loadingAssignPrimaryReceipt,
    called: calledAssignFinallReceipt || calledAssignPrimaryReceipt,
    // data,
  };
};

interface ServerRequestedData {
  AssignFinallCode: string;
  ReceiveDate: string; //میلادی
  ReceiveMatch: '0' | '1';
  ReceiveAmount: string;
  ReceivePricePerUnit: string;
  ReceiveTotalPrice: string;
  ReceiveComment: string;
}

interface ServerResponse {
  result: boolean;
  error: string;
  message: string;
  statusCode: '1' | '2';
  // 1 : اعلام وصول شده با عرضه
  // 2 : اعلام وصول شده بدون عرضه
}

interface AnounceDeliveryArgs {
  assignFinalCode: string;
  merchandiseId: string;

  date: string;
  receiveMatch: boolean;
  receiveAmount: string;
  receivePricePerUnit: string;
  receiveTotalPrice: string;
  receiveComment: string;
}
